import { userItemsPerListMixin } from '@/utils/vuex';
import userAccessPermissionMixin from '@/components/core/tenant/userAccessPermissionMixin';
import userListMixin from '@/components/core/tenant/userListMixin';
import compact from 'lodash/compact';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['email'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'CoreTenantUsersList',
  mixins: [userListMixin, userItemsPerListMixin, userAccessPermissionMixin],
  props: {
    userManageAccesses: {
      type: Array,
      required: false,
      default: () => []
    },
    selectedTenantId: {
      type: Number,
      required: false,
      default: null
    },
    tablePage: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      tableOptions: {
        ...defaultTableOptions
      },
      scopeDescencionMapping: {}
    };
  },
  computed: {
    fetchOptions() {
      return ['no-rules'];
    },
    tableLocalized() {
      return {
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        },
        headers: compact([{
          text: this.$i18n_t('Common.lastName'),
          value: 'lastName',
          sortable: true
        }, {
          text: this.$i18n_t('Common.firstName'),
          value: 'firstName',
          sortable: true
        }, {
          text: this.$i18n_t('Common.email'),
          value: 'email',
          sortable: true
        }, {
          text: this.$i18n_t('Common.active'),
          value: 'active',
          sortable: true,
          align: 'center'
        }, this.hasUserManagePermission || this.hasImpersonatePermission ? {
          text: this.$i18n_t('Common.actions'),
          value: '',
          sortable: false,
          align: 'right'
        } : null])
      };
    }
  },
  watch: {
    tablePage(newVal) {
      this.tableOptions.page = newVal;
    }
  },
  created() {
    this.tableOptions.page = this.tablePage || defaultTableOptions.page;
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
    this.doFetchSessionAccessDetails().then(() => {
      return this.fetchUsers();
    }).catch(e => {
      console.error('Error during user-fetch', e);
    });
  },
  methods: {
    editUser(user) {
      this.$store.commit('app/setTablePage', this.tableOptions.page || defaultTableOptions.page);
      this.$emit('editUser', user);
    }
  }
};